import axios from 'axios'
import config from '../Config';
export class SystemStatusService{
    private static URL:string = config.internalApiUrl;

    public static getAllSystemStatus(){
        let UserURL:string = `${this.URL}/system_status.php` 
        return axios.post(UserURL)
    }
}